import { memo } from "react";
import { Typography, useTheme } from "@mui/material";
import { FlexBox } from "@/components/baseComponents/FlexBox";
import Coins from "@/components/icons/Coins";
import { useGetUserRecordsCountQuery } from "@/apis/naniexpert/hooks/member";
import { useAuthContext } from "@/providers/authProvider/authContext";
import { AI_QUESTION_GENERATION_MAX_COUNT } from "@/utils/constants";

type Props = {
  variant?: "primary" | "secondary";
};

const RemainingCount = ({ variant = "primary" }: Props) => {
  const theme = useTheme();
  const { user } = useAuthContext();
  const { data: userRecordsCountData } = useGetUserRecordsCountQuery({
  enabled: !!user,
});

  const usedCount = userRecordsCountData?.count ?? 0;
  const remainingCount = AI_QUESTION_GENERATION_MAX_COUNT - usedCount;
  const isLimitReached = remainingCount <= 0;

  const displayText = isLimitReached
    ? "使用次數已達上限"
    : `剩餘次數：${remainingCount}`;

  return (
    <FlexBox gap={1}>
      <Coins
        width={32}
        height={32}
        {...(variant === "secondary" && {
          color1: theme.palette.primary.main,
          color2: theme.palette.primary.main,
          showLinerGradient: false,
        })}
      />
      <Typography variant="subtitle1">{displayText}</Typography>
    </FlexBox>
  );
};

export default memo(RemainingCount);
